import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import user_Store from "../store/user_store";
import cohort_Store from "../store/cohort_store";
import ExportCSV from "../functions/ExportCSV";
import Manage_Cohort_Modal from "../component/Manage_Cohort_Modal";
import YesNoAsk_Modal from "../component/YesNoAsk_Modal";
import student_Store from "../store/student_store";
import supervisor_Store from "../store/supervisor_store";
import admin_Store from "../store/admin_store";
import CurrUser from "../functions/UserAuth";
import { toast } from "react-toastify";
import styles from "../css/styles.module.css";

function Cohort_Page() {
  //#region stores
  // Student Store
  const student = student_Store((state) => state.student);
  // Supervisor Store
  const supervisor = supervisor_Store((state) => state.supervisor);
  // Admin Store
  const admin = admin_Store((state) => state.admin);
  // Cohort store
  const cohorts = cohort_Store((state) => state.cohorts);
  // all cohorts
  const getcohorts = cohort_Store((state) => state.getCohorts);
  // add cohort
  const addCohort = cohort_Store((state) => state.addCohort);
  // edit cohort
  const editCohort = cohort_Store((state) => state.editCohort);
  // delete cohort
  const deleteCohort = cohort_Store((state) => state.deleteCohort);
  //#endregion

  // //  let [selectValue, setSelectValue]= useState([])
  // function onSelect(actionId, id, setStatus, setClasss) {
  //   setStatus(actionId)
  //   let classvalue = actionId == 'Activated' ? 'success' : actionId == 'Deactivated' ? 'danger' : 'warning'
  //   setClasss(classvalue)
  //   putcohort({ status: actionId }, id, currentUser?.token)
  //   //   setClasss(classvalue)
  // }

  //#region variables
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const currentUser = CurrUser(student, supervisor, admin);

  // cohort name input
  let [name, setName] = useState("");

  // cohort name input
  let [instruction, setInstruction] = useState("");

  // cohort id
  let [id, setId] = useState(-1);

  // Add & Edit modal control
  const [isAdd, setIsAdd] = useState(false);

  // for holding data while search
  let [mydata, setMydata] = useState([]);

  // page for pagination
  const [page, setPage] = useState(1);
  // page for pagination
  const [perPage, setPerPage] = useState(10);

  //#endregion variables

  //#region functions

  // edit cohort
  const edit = (id) => {
    setId(id);
    const result = cohorts?.data?.find((cohort) => cohort.id === id);
    setName(result?.name);
    setInstruction(result?.instruction);
    setIsAdd(true);
  };
  // add cohort
  const add = (id) => {
    setId(-1);
    setName("");
    setInstruction("");
    setIsAdd(true);
  };
  // page pagination
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };

  // page pagination
  const handlePageChange = (page) => {
    setPage(page);
  };
  // page pagination
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  // searching data
  function onChange(e) {
    let word = e.target.value;
    const result = cohorts.data.filter(
      (cohort) =>
        (cohort.name &&
          cohort.name.toLowerCase().includes(word.toLowerCase())) ||
        cohort?.id == word
    );
    setMydata(result);

    if (word === "") {
      setMydata([]);
      setResetPaginationToggle(!resetPaginationToggle);
    }
  }

  // CSV Export
  function exportTable() {
    let arr = mydata.length > 0 ? mydata : cohorts.data;
    arr.forEach(
      (obj) =>
        (obj.created_at =
          new Date(obj?.created_at ?? "")
            ?.toLocaleString()
            ?.replace(",", "-") ?? "")
    );
    arr.forEach((obj, index) => (obj.id = index + 1));
    ExportCSV(arr, "cohorts");
  }

  //#endregion functions

  //#region constructor
  useEffect(() => {
    getcohorts(currentUser?.token);
  }, []);

  //#endregion constructor

  //#region Datatable column

  // selectors name should be same as in the database
  const columns = [
    {
      name: "ID",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "70px",
      id: 1,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "800px",
      id: 2,
    },
    {
      name: "Edit",
      cell: (row) => {
        return (
          <button
            onClick={function () {
              edit(row.id);
            }}
            className="btn text-white bg-primary btn-md"
            type="button"
          >
            <i className="bi bi-pencil"></i>
          </button>
        );
      },
      width: "60px",
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      name: "Delete",
      cell: (row) => {
        return (
          <button
            onClick={function () {
              handleShow();
              setId(row.id);
            }}
            className="btn text-white bg-danger btn-md"
            type="button"
          >
            <i class="bi bi-trash-fill"></i>
          </button>
        );
      },
      width: "130px",
      ignoreRowClick: true,
      allowOverflow: true,
    },
    // {
    //   name: "Status",
    //   cell: (row) => {
    //     let classs = row.status == 'Pending' ? 'warning' : row.status == 'Activated' ? 'success' : 'danger';
    //     const status = row.status
    //     return <Selector_Component classs={classs} row={row} onSelect={onSelect} status={status} />
    //   }
    //   ,
    //   ignoreRowClick: true,
    //   allowOverflow: true,

    //   // button: true,
    // },
  ];
  //#endregion table column

  const deleteItem = async () => {
    try {
      // check and validation for name existence
      const result = await deleteCohort(id);
      // success toast appear if we succeed
      if (result?.status == 200 || result?.status == 201) {
        let msg = "Cohort deleted successfully";
        toast.success(msg);
        // disappear modal
        handleClose();
        setShow(false);
        setIsAdd(false);
      }
    } catch (error) {
      const errmsg = error.response?.data?.message;
      if (!errmsg) return;
      // show error reason as an error toast
      if (Array.isArray(errmsg)) {
        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element);
          }, 200 * index);
        });
      } else {
        toast.error(errmsg);
      }
    }
  };

  const bodyMessage =
    "Do you really want to delete? This process cannot be undone.";

  //#region render
  return (
    <>
      <div className="row justify-content-between">
        <div className="col-4"></div>
        <div className="col-1"></div>
      </div>

      <div className="d-flex bd-highlight">
        <div className="pt-2 flex-grow-1 bd-highlight">
          <input
            type="text"
            onChange={(e) => onChange(e)}
            className="form-control w-50"
            placeholder="Search.."
            required
            aria-label=""
            aria-describedby="basic-addon1"
          />
        </div>
        <div className="p-2 bd-highlight  ">
          <button
            onClick={function () {
              add();
            }}
            className="btn text-white bg-primary btn-md col-12"
            type="button"
          >
            <i className="bi bi-plus-lg" aria-hidden="true"></i>
          </button>
        </div>
        <div className="p-2 bd-highlight">
          <button
            onClick={function () {
              exportTable();
            }}
            className="btn   btn-md btn btn-outline-primary"
            type="button"
          >
            CSV
          </button>
        </div>
      </div>

      {/* Datatable */}
      <DataTable
        title="Cohorts"
        columns={columns}
        data={mydata?.length > 0 ? mydata : cohorts.data}
        progressPending={false}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={
          mydata?.length > 0 ? mydata?.length : cohorts?.data?.length
        }
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />

      {/* Add & Edit Modal  */}
      <Manage_Cohort_Modal
        setIsAdd={setIsAdd}
        isOpen={isAdd}
        id={id}
        addData={addCohort}
        editData={editCohort}
        token={currentUser?.token}
        name={name}
        setName={setName}
        instruction={instruction}
        setInstruction={setInstruction}
      />

      {/* Delete Modal  */}
      <YesNoAsk_Modal
        title={"Are you sure?"}
        btnName={"Delete"}
        bodyMessage={bodyMessage}
        responseMessage={"Delete"}
        variant={"danger"}
        handleClose={handleClose}
        show={show}
        submitFunc={async function () {
          deleteItem();
        }}
      />
    </>
  );
  //#endregion render
}

export default Cohort_Page;
